var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3",staticStyle:{"max-height":"45vh","overflow-y":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }